import mdiSvg from './mdi-svg';
import md from './md';
import mdi from './mdi';
import fa from './fa';
import fa4 from './fa4';
import faSvg from './fa-svg';
export default Object.freeze({
  mdiSvg,
  md,
  mdi,
  fa,
  fa4,
  faSvg
});
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ./node_modules/vuetify/lib/services/icons/presets/index.js